import React from 'react';

type props = {
  children?: React.ReactNode;
};

const NavyBlueBackground = ({ children }: props) => {
  document.body.style.backgroundColor = 'rgb(22 19 62)';
  return <>{children}</>;
};

export default NavyBlueBackground;
